import tw from "twin.macro";
import styled from "styled-components";
import "@fontsource/orbitron"; // O la que elijas

export const SectionHeading = styled.h2`
  ${tw`text-2xl sm:text-5xl font-black tracking-wide text-center`}
  font-family: 'Orbitron', sans-serif;
`;

export const Subheading = styled.h5`
  ${tw`font-bold text-primary-500`}
  font-family: 'Orbitron', sans-serif;
`;
